<p-dialog
  *ngIf="visible"
  [header]="header"
  [style]="{ width: '75vw' }"
  [(visible)]="visible"
  modal="modal"
  (onHide)="close()"
  [closeOnEscape]="false"
  [focusOnShow]="false"
  appendTo="body"
  styleClass="link__dialog"
  [resizable]="true"
>
  <div class="link__search">
    <kpd-search
      [config]="searchConfig"
      [placeholder]="'Search...' | translate"
      [searchExpression]="searchExpression"
      [itemTotal]="createTotalCountLabel(totalCount)"
      [autofocus]="true"
      (updated)="onSearch($event)"
    >
    </kpd-search>
    <ng-content> </ng-content>
    <kpd-alert type="error" *ngIf="error" icon="error-standard"> {{ error }} </kpd-alert>
  </div>
  <div class="link__table">
    <kpd-spinner class="spinner--table" *ngIf="loading"> </kpd-spinner>
    <p-table
      class="dialog__table table__fullheight"
      #table
      dataKey="key"
      [value]="itemsFiltered"
      selectionMode="multiple"
      [metaKeySelection]="true"
      [responsive]="true"
      [scrollable]="true"
      [index]="index"
      scrollHeight="60vh"
      [resizableColumns]="true"
      columnResizeMode="fit"
      [kpdTableRowSelection]="selectedKeys"
      (selectionChanged)="onSelectionChanged($event)"
      (kpdTableSort)="onSort($event)"
      [itemsTotalCount]="totalCount"
      kpdTableScroll
      kpdDisableTextSelectionOnShiftClick
      [reorderableColumns]="true"
      [columns]="cols"
      [kpdTableSaveColumns]="header"
      kpdTableColumnReorder
    >
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" translate>No records found</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" [style.width]="col.width" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn [pSortableColumn]="col.field">
            {{ col.header }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
          <td *ngFor="let col of columns">
            <label *ngIf="!col.type">{{ rowData[col.field] }}</label>
            <ng-container
              *ngTemplateOutlet="tableExtraTemplate; context: { $implicit: col, item: rowData, index: rowIndex }"
            >
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <p-footer class="flex-row flex-align-items-center flex-space-between">
    <label class=""> <i translate>Number selected:</i> {{ selectedKeys.length }} </label>
    <div class="dialog__buttons flex-align-items-center flex-row">
      <button kpdHotkey="esc" type="button" class="button button--outline" icon="fa-close" (click)="close()">
        <span translate>Cancel</span>
      </button>
      <button
        [disabled]="selectedKeys.length < 1 || error"
        type="button"
        class="button button--main"
        icon="fa-trash"
        (click)="onAdd()"
      >
        <clr-icon shape="plus" size="16"></clr-icon>&nbsp; <span translate>Add</span>
      </button>
    </div>
  </p-footer>
</p-dialog>
